<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_government_intro')
}

const isOnGovernmentSection = computed(() => {
  return route.path.startsWith('/government')
})

const goToGovernment = () => {
  router.push('/government/cabinet')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/government.webm"
  >
    <template #text>
      <p class="pb-2">
        Welcome, I'm your governing advisor.
      </p>
      <p class="pb-2">
        I'll help you chose your cabinet.
      </p>
      <p class="pb-2">
        First, lets meet your candidates!
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="hidden md:flex">
        Click on the "Government" button in the top menu.
      </Alert>
      <Alert type="info" class="md:hidden">
        Click on the "Menu" in the right top of your screen, then select "Government".
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnGovernmentSection" @click="goToGovernment" class="mr-2">
        Go to Government
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Ok, i got it!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>